import { clearLocalStorageOnLogout } from 'actions/authentication';
import { REFRESH_TOKEN } from 'constants/localStorageConstants';
import { useIntercom } from 'react-use-intercom';
import { logout } from 'apis/authentication.api';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { featuresSelector } from 'reducers/userAuthSlice';

const Logout = () => {
	const { hardShutdown } = useIntercom();
	const dispatch = useDispatch();
	const refreshToken = localStorage.getItem(REFRESH_TOKEN);
	const features = useSelector(featuresSelector);
	const isUSpaceAccount = features?.uspace;

	useEffect(() => {
		const performLogout = async () => {
			await dispatch(logout(refreshToken));

			hardShutdown();
			clearLocalStorageOnLogout();

			const redirectUrl = isUSpaceAccount ? 'https://app.stradaai.com' : `${origin}/login`;
			window.location.assign(redirectUrl);
		};

		performLogout();
	}, [dispatch, hardShutdown, refreshToken, isUSpaceAccount]);

	return null;
};

export default Logout;
